export class PublicError extends Error {
  constructor(message: string) {
    super(message);
  }
}
